// Контактна інформація
export const CONTACT_INFO = {
  email: 'contact@alinapoloneye.com',
  instagram: {
    url: 'https://instagram.com/alina.poloneyeva/',
    handle: '@alina.poloneyeva',
  },
} as const;

// Intersection Observer thresholds
export const INTERSECTION_THRESHOLDS = {
  LOW: 0.1,
  MEDIUM: 0.15,
  HIGH: 0.2,
  VERY_HIGH: 0.3,
} as const;

// Затримки анімацій (ms)
export const ANIMATION_DELAYS = {
  INSTANT: 0,
  FAST: 100,
  MEDIUM: 200,
  SLOW: 300,
  VERY_SLOW: 400,
  EXTRA_SLOW: 600,
} as const;

// Scroll thresholds
export const SCROLL_THRESHOLDS = {
  SMALL: 5,
  MEDIUM: 30,
  LARGE: 50,
} as const;

// Touch/Swipe thresholds
export const SWIPE_THRESHOLDS = {
  MIN_MOVEMENT: 10,
  SWIPE_DISTANCE: 50,
} as const;

// Viewport calculations
export const VIEWPORT = {
  HERO_SECTION_PERCENT: 0.2, // 20% від viewport height
} as const;

// Timeout durations (ms)
export const TIMEOUTS = {
  SCROLL_END: 300,
  FADE_IN: 100,
} as const;

// Video paths - hosted on Cloudinary CDN for better performance and adaptive delivery
export const VIDEO_PATHS = {
  PORTRAIT: 'https://res.cloudinary.com/dpwrxfqo1/video/upload/v1771190238/portrait_v5oobm.mp4',
  LANDSCAPE: 'https://res.cloudinary.com/dpwrxfqo1/video/upload/v1771190162/landscape_uc8b9j.mp4',
} as const;
